import { render } from "./JumbaComponent.vue?vue&type=template&id=18bbe1b2"
import script from "./JumbaComponent.vue?vue&type=script&lang=js"
export * from "./JumbaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__